import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
//import { UniversalModule } from 'angular2-universal'; // <= ASP.NET Core

import {
    DxButtonModule,
    DxCheckBoxModule,
    DxFormModule,
    DxLoadIndicatorModule,
    DxSelectBoxModule,
    DxTemplateModule,
    DxTextBoxModule,
    DxValidatorModule
} from 'devextreme-angular';
import { DataServiceWebApiAdapter } from 'breeze-client/adapter-data-service-webapi';
import { ModelLibraryBackingStoreAdapter } from 'breeze-client/adapter-model-library-backing-store';
import { UriBuilderJsonAdapter } from 'breeze-client/adapter-uri-builder-json';
import { AjaxHttpClientAdapter } from 'breeze-client/adapter-ajax-httpclient';

// Components
import { Register } from './Register';
import { RegisterForm } from './RegisterForm';
import { RegisterComplete } from './RegisterComplete';
import { ResetPassword } from './ResetPassword';
import { ResetPasswordComplete } from './ResetPasswordComplete';
import { ResetPasswordVerified } from './ResetPasswordVerified';
import { RegisterExternal } from './RegisterExternal';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, '../../assets/i18n/', '.json');
}
@NgModule({
    bootstrap: [Register],
    imports: [
        //UniversalModule, // Must be first import. This automatically imports BrowserModule, HttpModule, and JsonpModule too.
        BrowserModule,
        HttpModule,
        RouterModule.forRoot([
            { path: '', redirectTo: 'Form', pathMatch: 'full' },
            { path: 'Form', component: RegisterForm },
            { path: 'Complete', component: RegisterComplete },
            { path: 'ResetPassword', component: ResetPassword },
            { path: 'ResetPasswordComplete', component: ResetPasswordComplete },
            { path: 'ResetPasswordVerified', component: ResetPasswordVerified },
            { path: 'External', component: RegisterExternal }
        ]),
        DxButtonModule,
        DxCheckBoxModule,
        DxFormModule,
        DxCheckBoxModule,
        DxLoadIndicatorModule,
        DxSelectBoxModule,
        DxTemplateModule,
        DxTextBoxModule,
        DxValidatorModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
    ],
    exports: [],
    declarations: [
        Register,
        RegisterForm,
        RegisterComplete,
        ResetPassword,
        ResetPasswordComplete,
        ResetPasswordVerified,
        RegisterExternal
    ],
    providers: [
        { provide: 'Claims', useFactory: () => window['Claims'] }
    ]
})
export class RegisterModule {
    constructor(http: HttpClient) {
        ModelLibraryBackingStoreAdapter.register();
        UriBuilderJsonAdapter.register();
        AjaxHttpClientAdapter.register(http);
        DataServiceWebApiAdapter.register();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Register/register.module.ts